import { dollarsToNum } from "@oneethos/shared"
import { DollarsInput } from "./forms"

export const FastTrackFields = ({ formData, handleChange, disabled }) => {
  const before = dollarsToNum(formData.avgMonthlyUtilityBill)
  const after = dollarsToNum(formData.estAvgMonthlyUtilityBillAfterSolar)

  return <div>
    <div className="adders-container">
      <div className="form-group">
        <label>Avg Monthly Utility Bill Before Solar*</label>
        <DollarsInput
          placeholder="$0.00"
          disabled={disabled}
          value={formData.avgMonthlyUtilityBill}
          onChange={v => handleChange({
            ...formData,
            avgMonthlyUtilityBill: v
          })}
        />
      </div>
      <div className="form-group">
        <label>Avg Monthly Utility Bill After Solar*</label>
        <DollarsInput
          placeholder="$0.00"
          disabled={disabled}
          value={formData.estAvgMonthlyUtilityBillAfterSolar}
          onChange={v => handleChange({
            ...formData,
            estAvgMonthlyUtilityBillAfterSolar: v
          })}
        />
      </div>
    </div>
    {(before && after) && (after >= before) ? (
      <div className="alert alert-danger">
        Avg Monthly Utility Bill After Solar must be less than Avg Monthly Utility Bill Before Solar to proceed.
      </div>
    ) : null}
    <div className="alert alert-secondary small">
      Projects under $150K for for-profit businesses may qualify for our FastTrack program if the solar
      loan provides immediate monthly savings. The program evaluates the owner&apos;s personal credit under
      our residential criteria, but the loan is issued to the business. Applicants must upload a utility bill.
    </div>
  </div>
}

export default FastTrackFields